var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasItemColorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.84 9.83L20.84 8.83C20.47 8.65 20.01 8.79 19.83 9.16C19.64 9.54 19.79 9.99 20.16 10.17L21.75 10.96V15.75L18 15.76V5.5C18 3.5 16.66 2.5 15 2.5H7C5.34 2.5 4 3.5 4 5.5V21.75H2.5C2.09 21.75 1.75 22.09 1.75 22.5C1.75 22.91 2.09 23.25 2.5 23.25H19.5C19.91 23.25 20.25 22.91 20.25 22.5C20.25 22.09 19.91 21.75 19.5 21.75H18V17.26L22.5 17.25C22.92 17.25 23.25 16.91 23.25 16.5V10.5C23.25 10.22 23.09 9.96 22.84 9.83ZM6.5 7.39C6.5 6 7.35 5.5 8.39 5.5H13.62C14.65 5.5 15.5 6 15.5 7.39V8.62C15.5 10 14.65 10.5 13.61 10.5H8.39C7.35 10.5 6.5 10 6.5 8.61V7.39ZM7 12.75H10C10.41 12.75 10.75 13.09 10.75 13.5C10.75 13.91 10.41 14.25 10 14.25H7C6.59 14.25 6.25 13.91 6.25 13.5C6.25 13.09 6.59 12.75 7 12.75Z",
    fill: "url(#paint0_linear_6263_73337)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6263_73337",
    x1: 12.5,
    y1: 2.5,
    x2: 12.5,
    y2: 23.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasItemColorIcon);
export default __webpack_public_path__ + "static/media/gas-item-color-icon.3babef33924503a30183a679c63d6061.svg";
export { ForwardRef as ReactComponent };